<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <!-- <ul>
                <li><a routerLink="/">Accueil</a></li>
                <li>Bienvenue</li>
            </ul> -->
            <h2 style="color:white">L'école s'inspire du texte de Actes 19: 8 -10
            </h2>
            <h5 style="font-size:16px !important;color:white">
                « 8. Ensuite Paul entra dans la synagogue, où il parla librement. Pendant trois mois, il discourut sur
                les choses qui concernent le royaume de Dieu, s'efforçant de persuader ceux qui l'écoutaient.
                9. Mais, comme quelques-uns restaient endurcis et incrédules, décriant devant la multitude la voie du
                Seigneur, il se retira d'eux, sépara les disciples, et enseigna chaque jour dans l'école d'un nommé
                Tyrannus.
                10. Cela dura deux ans, de sorte que tous ceux qui habitaient l'Asie, Juifs et Grecs, entendirent la
                parole du Seigneur ».

            </h5>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class=" asset profile-authentication-area pb-100">
    <div class="container">
        <div class="row h-100 justify-content-center align-items-center">

            <div class="col-lg-6 col-md-12" style="margin-bottom:5px">
                <div class="login-form">
                    <h2>Nouveau mot de passe</h2>
                    <form [formGroup]="resetPasswordForm" ngNativeValidate (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label>Mot de passe</label>
                            <input required formControlName="password" name="password" type="password" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>Confirmez le mot de passe</label>
                            <input required formControlName="confirmpassword" name="confirmpassword" type="password" class="form-control">
                        </div>
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-6 col-sm-6 remember-me-wrap">
                                <p>
                                    
                                </p>
                            </div>
                            <div *ngIf="!isAuthenticated" class="col-lg-6 col-md-6 col-sm-6 lost-your-password-wrap">
                                <a  [routerLink]="'/login'" class="lost-your-password">S'identifier</a>
                            </div>
                            <div *ngIf="isAuthenticated" class="col-lg-6 col-md-6 col-sm-6 lost-your-password-wrap">
                                <a  [routerLink]="'/'" class="lost-your-password">Accueil</a>
                            </div>
                        </div>
                        <div *ngIf="error || message"
                            [ngClass]="{'text-danger':error,'text-success':message, 'bg-danger':error,'bg-success':message}"
                            class="card" style="margin-top:24px;">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" [ngClass]="{'text-danger':error,'text-success':message}">
                                    {{error||message}}
                                </li>
                            </ul>
                        </div>
                        <button type="submit" [disabled]="showSpinner" class="btn btn-success" type="submit">valider<span
                            *ngIf="showSpinner" class="spinner-border spinner"></span></button>                    
                        </form>
                </div>
            </div>
        </div>
    </div>
</div>
